import { useMemo } from 'react';

/**
 * This hook detects if the current device supports touch input.
 *
 * It checks for touch capability using multiple methods for maximum
 * compatibility:
 *
 * - `ontouchstart` in window (modern browsers)
 * - `navigator.maxTouchPoints` (modern browsers)
 * - `navigator.msMaxTouchPoints` (IE compatibility)
 *
 * @returns `true` if the device supports touch input, `false` otherwise
 */
export function useTouchDevice(): boolean {
  const isTouchDevice = useMemo(() => {
    // Handle SSR environments where window/navigator might not be available
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      // @ts-expect-error - for IE compatibility
      navigator.msMaxTouchPoints > 0
    );
  }, []);

  return isTouchDevice;
}
